import _ from 'lodash'

export default {
  name: 'folderSet',
  props: ['disk_list'],
  components: {},
  data: function () { return { hide_docker_overlay : true } },
  computed: {
    folder_max_len() { return _.max(_.map(this.disk_list, x => x.mountpoint.length)) + 3 }
  },
  methods: {},
  created: function() {   console.log('folderSet.vue', 'created'); },
  destroyed: function() { console.log('folderSet.vue', 'destroyed'); },
  mounted: function() { console.log('folderSet.vue', 'mounted'); }

}
